import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { Order } from 'models/order';
import { OrderItemEvent, OrderItemEventType } from 'models/order-item-events';
import { AccountArrowRight } from 'mdi-material-ui';

type LinkedDentistsIconButtonProps = {
    order: Order;
    onOrderItemEvent?: (event: OrderItemEvent) => void;
};
const LinkedDentistsIconButton: FC<LinkedDentistsIconButtonProps> = ({
    order,
    onOrderItemEvent,
}: LinkedDentistsIconButtonProps) => {
    const { t: translate } = useTranslation(['orders']);

    return (
        <Tooltip title={<span>{translate('orders:MANAGE_PARTICIPANTS')}</span>}>
            <IconButton
                size="small"
                onClick={(e) => {
                    e.stopPropagation();
                    if (onOrderItemEvent) {
                        onOrderItemEvent({
                            order: order,
                            eventType: OrderItemEventType.MANAGE_LINKED_DENTISTS,
                        });
                    }
                }}
            >
                {order.linkedDentists?.length > 0 ? (
                    <AccountArrowRight />
                ) : (
                    <AccountArrowRight sx={{ color: '#f2f2f2' }} />
                )}
            </IconButton>
        </Tooltip>
    );
};

export default LinkedDentistsIconButton;
